import React, { useState, useEffect } from "react";

function ProjectReports() {
  const [projectReports, setProjectReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(false);
  const [message, setMessage] = useState("");
  const [departments, setDepartments] = useState([]);

  // Helper function to make authenticated requests
  const authFetch = async (url, options = {}) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers
    };
    return fetch(url, { ...options, headers });
  };

  // Fetch project reports and departments
  useEffect(() => {
    const fetchData = async () => {
      setLoadingReports(true);
      setMessage("");
      
      try {
        // Fetch departments with authentication
        const deptRes = await authFetch("/api/professors/department_list");
        if (deptRes.ok) {
          const deptData = await deptRes.json();
          setDepartments(deptData);
        } else {
          const err = await deptRes.json();
          setMessage(err.detail || "Failed to fetch departments.");
        }

        // Fetch project reports with authentication
        const res = await authFetch("/api/professors/project_report");
        if (res.ok) {
          const data = await res.json();
          setProjectReports(data);
        } else {
          const err = await res.json();
          setMessage(err.detail || "Failed to fetch project reports.");
        }
      } catch (error) {
        setMessage("Network error.");
        console.error("Fetch error:", error);
      }
      setLoadingReports(false);
    };

    fetchData();
  }, []);

  // Download project report handler
  const handleDownloadReport = async (sip_id, studentName) => {
    try {
      const res = await authFetch(`/api/professors/project_report/${sip_id}`);
      if (!res.ok) {
        const err = await res.json();
        setMessage(err.detail || "Failed to download report.");
        return;
      }
      
      // Get filename from Content-Disposition header if available
      const disposition = res.headers.get("Content-Disposition");
      let filename = "project_report.pdf";
      if (disposition && disposition.indexOf("filename=") !== -1) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, "")
          .trim();
      } else if (studentName) {
        filename = `${studentName}_project_report.pdf`;
      }
      
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setMessage("Network error while downloading report.");
      console.error("Download error:", error);
    }
  };

  // Confirm project report
  const handleConfirmReport = async (sip_id) => {
    try {
      const res = await authFetch(`/api/project_report/${sip_id}`, {
        method: "POST",
      });
      
      if (res.ok) {
        const data = await res.json();
        setMessage(data.message || "Project report confirmed!");
        // Refresh the table
        const updatedRes = await authFetch("/api/professors/project_report");
        if (updatedRes.ok) {
          setProjectReports(await updatedRes.json());
        }
      } else {
        const err = await res.json();
        setMessage(err.detail || "Failed to confirm report.");
      }
    } catch (error) {
      setMessage("Network error while confirming report.");
      console.error("Confirm error:", error);
    }
  };

  return (
    <div className="project-reports">
      <h2>All Project Reports</h2>
      {loadingReports ? (
        <p>Loading...</p>
      ) : projectReports.length === 0 ? (
        <p>No project reports submitted yet.</p>
      ) : (
        <div className="reports-table-container">
          <table className="students-table">
            <thead>
              <tr>
                <th>Student Name</th>
                <th>SIP ID</th>
                <th>Project Title</th>
                <th>Department</th>
                <th>Download Report</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {projectReports.map((student) => (
                <tr key={student.sip_id}>
                  <td>{student.name}</td>
                  <td>{student.sip_id}</td>
                  <td>{student.project_title}</td>
                  <td>{departments.find(d => d.id === student.department_id)?.name || 'N/A'}</td>
                  <td>
                    <button
                      className="sidebar-btn"
                      style={{ width: "120px", marginTop: 0, background: "#1976d2", color: "#fff" }}
                      onClick={() => handleDownloadReport(student.sip_id, student.name)}
                    >
                      Download
                    </button>
                  </td>
                  <td>
                    {student.project_report_approval ? (
                      <span style={{ color: "green" }}>Confirmed</span>
                    ) : (
                      <button
                        className="sidebar-btn"
                        style={{ width: "120px", marginTop: 0, background: "#388e3c", color: "#fff" }}
                        onClick={() => handleConfirmReport(student.sip_id)}
                      >
                        Confirm
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {message && (
        <p className="message" style={{
          color: message.includes("success") || message.includes("confirmed") ? "green" : "red",
          marginTop: "1rem"
        }}>
          {message}
        </p>
      )}
    </div>
  );
}

export default ProjectReports;